import { render, staticRenderFns } from "./policy-form.vue?vue&type=template&id=84fd0dce&scoped=true&"
import script from "./policy-form.vue?vue&type=script&lang=js&"
export * from "./policy-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-form.vue?vue&type=style&index=0&id=84fd0dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fd0dce",
  null
  
)

export default component.exports